// Конфигурация окружения и флагов
import {
  isBrowser,
  isServer,
  isProduction,
  isDevelopment,
  isTest,
  isE2E,
  showDebugPanel,
  getCollectionName,
  getEnvironment
} from './core/environment';

// Re-export environment variables for backward compatibility
export const NODE_ENV = getEnvironment();

// Cache environment values for performance
const ENV = {
  IS_PRODUCTION: isProduction(),
  IS_DEVELOPMENT: isDevelopment(),
  IS_TEST: isTest(),
  IS_BROWSER: isBrowser(),
  IS_SERVER: isServer()
} as const;

// Legacy export for backward compatibility
export const DEBUG = {
  IS_E2E: isE2E(),
  SHOW_DEBUG_PANEL: showDebugPanel()
} as const;

// Export all environment variables
export const {
  IS_PRODUCTION,
  IS_DEVELOPMENT,
  IS_TEST,
  IS_BROWSER,
  IS_SERVER
} = ENV;

// Firebase configuration
// Using the same project ID as in firebaseConfig.ts
const FIREBASE_PROJECT_ID = 'psyco-d2df6';
const FIREBASE_API_URL = process.env.FIREBASE_API_URL || 'https://europe-west1-psyco-8d8f9.cloudfunctions.net/api';

/**
 * Application Configuration
 * 
 * This is the central configuration object for the application.
 * All environment-specific settings should be managed through this object.
 */
export const CONFIG = {
  // Environment information
  ENV: {
    isProduction: IS_PRODUCTION,
    isDevelopment: IS_DEVELOPMENT,
    isTest: IS_TEST,
    isE2E: DEBUG.IS_E2E,
    isBrowser: IS_BROWSER,
    isServer: IS_SERVER,
  },
  
  // Firebase configuration
  FIREBASE: {
    PROJECT_ID: FIREBASE_PROJECT_ID,
    API_URL: FIREBASE_API_URL,
  },
  
  // Debug flags
  DEBUG: {
    IS_E2E: DEBUG.IS_E2E,
    SHOW_DEBUG_PANEL: DEBUG.SHOW_DEBUG_PANEL,
  },
  
  // Collection names
  COLLECTIONS: {
    // Get the appropriate collection name based on environment
    get RESULTS() {
      return getCollectionName();
    },
    
    // Alias for backwards compatibility
    get RESULTS_COLLECTION() {
      console.warn('[CONFIG] RESULTS_COLLECTION is deprecated. Use CONFIG.COLLECTIONS.RESULTS instead');
      return this.RESULTS;
    },
  },
  
  // Feature flags
  FEATURES: {
    // Add feature flags here as needed
    // Example: ENABLE_NEW_FEATURE: !isProduction || getDebugFlag('ENABLE_NEW_FEATURE'),
  },
  
  // API endpoints
  API: {
    // Define API endpoints here
    // Example: BASE_URL: isProduction ? 'https://api.example.com' : 'https://dev-api.example.com',
  },
  
  // Application settings
  APP: {
    VERSION: process.env.REACT_APP_VERSION || '1.0.0',
    NAME: 'Psyco App',
    DESCRIPTION: 'Psychological Testing Application',
  },
};

// Логирование конфигурации
console.log('[CONFIG]', {
  ENV: CONFIG.ENV,
  DEBUG: CONFIG.DEBUG,
  COLLECTIONS: {
    RESULTS: CONFIG.COLLECTIONS.RESULTS,
  },
  location: typeof window !== 'undefined' ? window.location.href : 'server',
  userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : 'server',
});